import React from 'react';
import VerificationComplianceDetailSection from '../../../sections/AdminDashboard/VerificationCompliance/VerificationComplianceDetail';

const VerificationComplianceDetail = () => {
  return <VerificationComplianceDetailSection />;
};

export default VerificationComplianceDetail;


